import { render, staticRenderFns } from "./addLuckyBag.vue?vue&type=template&id=a7afd79a&scoped=true"
import script from "./addLuckyBag.vue?vue&type=script&lang=js"
export * from "./addLuckyBag.vue?vue&type=script&lang=js"
import style0 from "./addLuckyBag.vue?vue&type=style&index=0&id=a7afd79a&prod&lang=scss&scoped=true"
import style1 from "./addLuckyBag.vue?vue&type=style&index=1&id=a7afd79a&prod&lang=scss"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7afd79a",
  null
  
)

export default component.exports